module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-6.e86f5add.jpg";